<template>
  <div>
    <div class="amount-row">
      <MoneyFormat
        :value="18"
        :currencyCode="form.currency"
        class="amount-box"
        style="width: 80px;margin-right: 10px;"
      />
      x
      <input
        id="ticketsQnt"
        type="number"
        min="1"
        name="ticketsQnt"
        placeholder="Bencher Quantity"
        v-model="ticketsQnt"
        style="margin: 0 10px;width: 180px"
      />
      =
      <MoneyFormat
        :value="form.amount ? amount : 0"
        :currencyCode="form.currency"
        class="amount-box"
        style="width: 100px;margin-left: 10px;"
      />
    </div>
  </div>
</template>
<script lang="ts">
import { computed, defineComponent, type PropType, ref, watch } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";

import type { Currency } from "~/form-settings";
import { queryParams } from "~/shared/query-params";

export default defineComponent({  setup() {
    const { setValue, form, settings, getValue } = usePaymentForm();

    setValue("custom.ticketsQnt", "" + 1);
    const ticketsQnt = ref();

    watch(ticketsQnt, () => {
      if (ticketsQnt.value) {
        setValue("amount", "" + 18 * ticketsQnt.value);
        setValue("custom.ticketsQnt", ticketsQnt.value);
      }
    });

    const amount = computed(() =>
      form.value.handleProcessing
        ? Math.round((+form.value.amount! + +form.value.amount! * 0.025) * 100) / 100
        : +form.value.amount!
    );

    return {
      form,
      amount,
      ticketsQnt,
      // clearOutSelectedValue,
    };
  },
});
</script>
<style scoped lang="scss">
  .amount-row {
    display: flex;
    align-items: center;
  }
  .amount-box {
    height: 44px;
    width: 100%;
    display: block;
    border: 1px solid #ddd;
    padding: 0 10px;
    border-radius: 4px;
    background: #f7f9fb;
    transition: all 0.3s ease-in-out;
    font-size: 16px;
    color: #ccc;
    display: flex;
    align-items: center;
    cursor: not-allowed;
  }
</style>
